import { render, staticRenderFns } from "./LocalDispatchIcon.vue?vue&type=template&id=bb3fabea"
import script from "./LocalDispatchIcon.vue?vue&type=script&lang=js"
export * from "./LocalDispatchIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports